export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export const faqs: FaqItem[] = [
  {
    id: "f1",
    question: "你们说的“选美吃瓜内定”是下定论吗？",
    answer:
      "不是。我们处理的是公开可查的线索，比如评分口径差异、评委利益关系、计分流程留痕。文章会明确区分“已经确认的事实”和“仍然存疑的推测”，也不会把统计上的重复直接等同于交易。",
  },
  {
    id: "f2",
    question: "评分猫腻一般出现在哪几个环节？",
    answer:
      "集中在四处：分项权重是否赛前锁死、同分如何处理、纸质分与电子分不一致时以谁为准、以及赛后是否对分数做过未公示的调整。这四处只要有任意一处没有写明，就存在被操作的空间。",
  },
  {
    id: "f3",
    question: "为什么赞助品牌出现在评委席值得关注？",
    answer:
      "赞助本身是赛事正常运作的一部分，不值得指责。真正需要关注的是赞助方代表是否与参赛机构存在历史交集，以及这种情况下回避机制有没有被触发、有没有留下书面记录。缺少披露，是问题的根源，而不是赞助行为本身。",
  },
  {
    id: "f4",
    question: "你们怎么判断一条爆料是否可信？",
    answer:
      "我们看四件事：能否与公开记录交叉验证、时间线是否自洽、是否只有单一匿名信源、以及爆料者是否有明确的利益诉求。任何一条不满足，我们都会在文中标注不确定等级，而不是直接当成结论使用。",
  },
  {
    id: "f5",
    question: "普通观众自己能复核一场比赛吗？",
    answer:
      "可以，而且不需要内部资料。先比对各渠道公布的分项名称是否一致，再检查各分项权重相加是否等于百分之百，最后确认同分处理规则有没有提前写明。三步里有两步对不上，就说明计分流程存在可被操作的空间。",
  },
  {
    id: "f6",
    question: "我可以向你们投递线索吗？",
    answer:
      "可以。我们更希望你提供可核查的物料，比如公示照片、通稿截图、赛程文件或票数变化记录，而不是转述类的文字。投递后我们会先做交叉验证，确认可用的部分才会进入选题流程，并且不会公开你的身份信息。",
  },
];